<script>
export default {
	props: {
		to: [Object, String],
	},
	computed: {
		comp() {
			if (!this.to) {
				return { is: 'div', attrs: {} }
			}

			if (typeof this.to === 'string') {
				let origin = this.$ssr?.req.origin || this.$window?.location?.origin || ''
				if (this.to.startsWith(origin)) {
					return { is: 'router-link', attrs: { to: this.to.slice(origin.length) } }
				}
				let protocol = this.to.match(/^([a-z]+):/i)?.[1]
				if (!protocol) {
					return { is: 'router-link', attrs: { to: this.to } }
				}
				if (protocol == 'goto') {
					return {
						is: 'a',
						attrs: { href: '#' },
						listeners: {
							click: (e) => {
								e.preventDefault()
								let [selector, offset, duration] = this.to.slice(5).split(':')
								this.$vuetify.goTo(selector, {
									offset: parseInt(offset) || 0,
									duration: parseInt(duration) || 500,
								})
							},
						},
					}
				} else {
					return { is: 'a', attrs: { href: this.to, target: '_blank' } }
				}
			}

			return { is: 'router-link', attrs: { to: this.to } }
		},
	},
}
</script>

<template>
	<component
		:is="comp.is"
		v-bind="{ ...$attrs, ...comp.attrs }"
		v-on="{ ...$listeners, ...(comp.listeners || {}) }"
	>
		<slot />
	</component>
</template>

